// A signal's icon is either a single emoji (often 2 UTF-16 code units as a
// surrogate pair, but one visual glyph) or a short typed label like "AB" or
// "42" (see TemplateManageScreen.tsx's SignalEmojiPicker). Array.from splits
// by Unicode code point rather than UTF-16 unit, so a real emoji still
// counts as one character here - only an actual multi-character label
// should get the smaller, denser font used to fit 2 characters in a badge
// sized for a single emoji glyph.
export function isMultiCharSignalIcon(icon: string): boolean {
  return Array.from(icon).length > 1;
}
